export default "__VITE_ASSET__QcQ_rfri__"